(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectViewLastDataController', TabObjectViewLastDataController)
        .filter('Find', function() {
            return function(input, str) {
                var tmp = {};
                angular.forEach(input, function(val, key) {
                    if (key.toLowerCase().match(str.toLowerCase())) {
                        tmp[key] = val;
                    }
                });
                return tmp;
            };
        });

    TabObjectViewLastDataController.$inject = ['$state', '$stateParams', '$scope', 'entity', 'uniqueCode'];

    function TabObjectViewLastDataController($state, $stateParams, $scope, entity, uniqueCode) {
        var vm = this;
        vm.tabObjectMetrics = entity;
        vm.objectUniqueCode = uniqueCode;

        vm.tabObjectMetrics.$promise.then(function (data) {
            vm.tabObjectMetrics = data;
        });
    }
})();
